import { fedColumns } from "../features/leads/FederalLeadsColumns";
import { sledColumns } from "../features/leads/SledLeadsColumns";
import { useGetLeadsContracts } from "../features/leads/useGetLeadsContracts";
import { DataTable } from "../components/ui/datatable";
import PageLayout from "../ui/PageLayout";
import ButtonHelp from "../ui/ButtonHelp";
import Session from "supertokens-auth-react/recipe/session";
import { PermissionClaim } from "supertokens-auth-react/recipe/userroles";
import EmptyTableCTA from "@/ui/EmptyTableCTA";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useState } from "react";
import { grantColumns } from "../features/leads/GrantLeadsColumns";
import { sbirColumns } from "../features/leads/SbirLeadsColumns";
import { useNavigate } from "react-router-dom";
import { toTitleCase } from "../utils/helpers";

const steps = [
  {
    target: "#leads",
    content: "Saved opportunities are listed here",
    title: "Saved Opportunities",
    placement: "center",
    disableBeacon: true,
  },
];

const searchTypes = [
  {
    key: "federal",
    label: "Federal",
    columns: fedColumns,
  },
  {
    key: "sled",
    label: "State",
    columns: sledColumns,
  },
  {
    key: "grant",
    label: "Grants",
    columns: grantColumns,
  },
  {
    key: "sbir",
    label: "SBIR/STTRs",
    columns: sbirColumns,
  },
];

function Leads() {
  const { data: leads, isLoading } = useGetLeadsContracts();
  const [searchType, setSearchType] = useState("federal");
  const navigate = useNavigate();
  const claimValue = Session.useClaimValue(PermissionClaim);
  const permissions = claimValue.value;
  const isSledPermission =
    Array.isArray(permissions) && permissions.includes("sled");

  const filteredSearchTypes = searchTypes.filter(
    (searchType) => searchType.key === "federal" || isSledPermission
  );

  function onValueChange(value) {
    setSearchType(value);
  }

  const handleNavigateToSearch = () => {
    navigate(`/search?searchType=${searchType}`);
  };
  const message = `Discover ${toTitleCase(searchType)} Opportunities to Save`;

  const currentLeads = leads && leads[searchType];
  const hasLeads = currentLeads && currentLeads.length > 0;

  return (
    <div>
      <div id="leads">
        <PageLayout
          heading="Saved Opportunities"
          description="Explore and manage your saved government contract opportunities."
        >
          <div className="space-y-2">
            <Select defaultValue="federal" onValueChange={onValueChange}>
              <SelectTrigger className="w-36 border-2 bg-secondary text-md font-semibold text-secondary-foreground">
                <SelectValue placeholder="Select a search type" />
              </SelectTrigger>
              <SelectContent>
                {filteredSearchTypes.map((searchType) => (
                  <SelectItem key={searchType.key} value={searchType.key}>
                    {searchType.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            {!hasLeads ? (
              <div className="p-10">
                <EmptyTableCTA
                  message={message}
                  subMessage="Click the button below to explore opportunities tailored for you."
                  buttonLabel="Start Searching"
                  onButtonClick={handleNavigateToSearch}
                  isFetching={isLoading}
                />
              </div>
            ) : (
              <DataTable
                columns={
                  searchTypes.find((type) => type.key === searchType).columns
                }
                data={currentLeads.map((lead) => ({
                  ...lead,
                  searchType,
                }))}
                isLoading={isLoading}
              />
            )}
          </div>
        </PageLayout>
      </div>
      <ButtonHelp steps={steps} />
    </div>
  );
}

export default Leads;
